/** @jsxImportSource react */
import { VerticalElectionChart } from "./VerticalElectionChart";

export function EscrutinioEnVivoView() {
  return (
    <div
      className="flex h-full flex-col overflow-hidden p-6"
      style={{ backgroundColor: "#F4F8FB" }}
    >
      {/* Main Content Panel */}
      <div className="flex min-h-0 flex-1 flex-col rounded-lg border border-slate-200 bg-white shadow-sm">
        {/* Panel Content */}
        <div className="flex min-h-0 flex-1">
          <VerticalElectionChart />
        </div>
      </div>
    </div>
  );
}
